import ImagesAuthenticationSignInSignInBackgroundWebp from '@/public/images/authentication/sign-in/sign-in-background.webp';
import ImagesAuthenticationSignInSignInBannerWebp from '@/public/images/authentication/sign-in/sign-in-banner.webp';
import ImagesAuthenticationSignInWatchPasswordSvg from '@/public/images/authentication/sign-in/watch-password.svg';

export {
  ImagesAuthenticationSignInSignInBackgroundWebp,
  ImagesAuthenticationSignInSignInBannerWebp,
  ImagesAuthenticationSignInWatchPasswordSvg,
};
